import type { PeriodUsageMetric } from '@/types'

// CHECKPOINT: PRD-14 FR-14.1.6 — Present API-provided metering without client-side plan assumptions.
export function formatUsagePeriodEnd(value: string): string {
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return 'the next reset'

  return date.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: date.getFullYear() !== new Date().getFullYear() ? 'numeric' : undefined,
  })
}

// CHECKPOINT: PRD-14 FR-14.1.6 — Warning copy gives a safe remediation path without exposing lane internals.
export function usageWarningMessage(metric: PeriodUsageMetric, direction: 'inbound' | 'outbound'): string | null {
  if (metric.warning === 'at_limit') {
    return direction === 'outbound'
      ? 'Outbound sending is at this period’s allowance. Upgrade or wait for the reset to send more.'
      : 'Inbound delivery is at this period’s allowance. Review storage or upgrade to keep receiving mail.'
  }
  if (metric.warning === 'critical') return `${direction === 'outbound' ? 'Outbound sending' : 'Inbound delivery'} is nearly at its allowance.`
  if (metric.warning === 'warning') return `${direction === 'outbound' ? 'Outbound sending' : 'Inbound delivery'} is approaching its allowance.`
  return null
}
